import { cast } from '@/mocks/russianMom';

export default function CastSection() {
  return (
    <section id="cast" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
            <i className="ri-group-line" aria-hidden="true"></i>
            主要角色
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            六位人物，撑起一屋子的沉默与牵挂
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            每个角色都有自己的立场与难处。正是他们各自的坚持，让这个家庭的故事显得可信而动人。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {cast.map((c) => (
            <article
              key={c.id}
              className="group flex gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-200"
            >
              <div className="h-24 w-24 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img src={c.img} alt={`${c.name}（${c.role}）剧照`} className="h-full w-full object-top object-cover" />
              </div>
              <div className="min-w-0">
                <h3 className="font-heading text-base font-bold text-foreground-950">{c.name}</h3>
                <p className="mt-0.5 text-xs text-primary-700">{c.role}</p>
                <p className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-user-star-line" aria-hidden="true"></i>
                  饰演 {c.actor}
                </p>
                <p className="mt-2 text-xs leading-6 text-foreground-600">{c.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}